document.addEventListener('DOMContentLoaded', function () {

  (() => {

    // Modal: 
    const open    = document.querySelector(".location__wrapper");
    const modal   = document.querySelector(".location__modal-wrapper");
    const close   = document.querySelector(".location__modal-close--icon");
    const form    = document.querySelector(".location__form");
    const action  = document.querySelector('.location__modal-action');
    const options = document.querySelectorAll(".location__modal-type-option")

    // Selects: 
    const selectLevel1 = document.getElementById('level-1');
    const selectLevel2 = document.getElementById('level-2');
    const storeOptions = Array.from(selectLevel2.querySelectorAll('option[data-city]'));   

    // General: 
    const url = window.location.href;
    const paramKey = document.getElementById('locations-available')?.dataset.locationsAvailableDefinition || 'filter.v.m.locations.available';
    const locationUserSettings = {
      "shippingType": "shipping",
      "city": "",
      "store": "",
      "paramKey": ""
    };

    const openModal = (open) => {
      // Listener para abrir el modal de sucursales al hacer click:
      if (open) {
        open.addEventListener("click", () => {
          setModalConfiguration(modal, options);
          localStorage.setItem('locationUserSettingsOpenedByUser', true);
        });

        // Listener para ocultar el tooltip al pasar el mouse sobre el accionardor del modal:
        open.addEventListener('mouseenter', (event) => {
          event.preventDefault();
          const locationTooltip = document.getElementById('location-tooltip');
          if (locationTooltip) {
            locationTooltip.style.display = 'none';
          }
        });
      }
    };

    const closeModal = (close) => {
      // Botón para cerrar el modal de Locations:
      if (close) {
        close.addEventListener("click", () => {

          if (modal) {
            modal.style.display = "none";
            localStorage.setItem('locationUserSettingsClosed', true);
          }

          if (!localStorage.getItem('locationUserSettingsOpenedByUser') && localStorage.getItem('locationUserSettingsClosed') == 'true' && !localStorage.getItem('locationUserSettingsSaved')) {
            setTimeout(() => {
              const locationTooltip = document.getElementById('location-tooltip');
              locationTooltip.style.display = 'flex';
            }, 3000)
          }

        });
      }
    };

    const saveInfo = (action) => {
      // Botón de Guardar: 
      if (action) {
        action.addEventListener('click', (event) => {

          console.log('Guardando información...');
          event.preventDefault();

          // Tipos de envios: Envio a domicilio - Retiro en tienda
          const shippingTypes = document.querySelectorAll('.location__modal-type-options .location__modal-type-option');

          if (shippingTypes && form) {
            shippingTypes.forEach(type => {
              if (type.classList.contains('location__modal-type-option--active')) {

                if (type.dataset.locationOption.trim() === 'shipping') {

                  locationUserSettings.shippingType = type.dataset.locationOption.trim();
                  locationUserSettings.city = "";
                  locationUserSettings.store = "";
                  locationUserSettings.paramKey = "";
                  locationUserSettings.paramValue = "";
                  localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings));
                  modal.style.display = "none";

                  setSelectedStore();

                  localStorage.setItem('locationUserSettingsSaved', true);

                  updateLocationParamInUrl(paramKey);

                  // window.location.reload();

                } else {

                  const options = form.querySelectorAll('.location__form-item .location__select');
                  const values = Array.from(options).map((option) => option.value.trim() !== "");
                  const validation = values.every(value => value === true);

                  removeError();

                  if (values.includes(false)) {
                    form.insertAdjacentHTML('beforeend', `<span id="location__error" class="location__error">Debes seleccionar la ciudad y la tienda.</span>`);
                  }

                  if (validation === true) {
                    locationUserSettings.city = selectLevel1.value;
                    locationUserSettings.store = selectLevel2.value;
                    locationUserSettings.shippingType = "pickup";
                    locationUserSettings.paramKey = `${paramKey}`;
                    locationUserSettings.paramValue = `${selectLevel2.value}`;

                    localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings));
                    modal.style.display = "none";

                    setSelectedStore();

                    localStorage.setItem('locationUserSettingsSaved', true);

                    updateLocationParamInUrl(paramKey);

                    // window.location.reload();
                   
                  }

                }

              }
            });

            const currentPath = window.location.pathname;
            if (currentPath.includes('/products')) window.location.reload();

          }

        });
      }
    };

    const setDeliveryOptions = (options) => {
      // Selector de tipo de Envio
      if (options) {
        // Envio a Domicilio o Retiro en Tienda
        options.forEach((option) => {

          if (localStorage.getItem('locationUserSettings') !== null) { // Si la configuración tiene valores en el local storage.
            const locationUserSettings = JSON.parse(localStorage.getItem('locationUserSettings'));

            if (form && option.dataset.locationOption === "shipping" && locationUserSettings.shippingType === "shipping") {

              option.classList.add('location__modal-type-option--active');
              locationUserSettings.city = "";
              locationUserSettings.store = "";
              locationUserSettings.paramKey = "";
              locationUserSettings.paramValue = "";
              form.style.display = "none";
              localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings));

            } else if (form && option.dataset.locationOption === "pickup" && locationUserSettings.shippingType === "pickup") {

              option.classList.add('location__modal-type-option--active');
              form.style.display = "flex";

            }
          }

          option.addEventListener("click", () => {

            // Remover la clase "active" de todos los elementos
            document.querySelectorAll(".location__modal-type-option").forEach((el) =>
              el.classList.remove("location__modal-type-option--active")
            );

            // Agregar la clase "active" al elemento clickeado
            option.classList.add("location__modal-type-option--active");
            locationUserSettings.shippingType = option.dataset.locationOption.trim();

            if (form && option.dataset.locationOption === "shipping") {

              locationUserSettings.city = "shipping";
              locationUserSettings.city = "";
              locationUserSettings.store = "";
              locationUserSettings.paramKey = "";
              locationUserSettings.paramValue = "";
              form.style.display = "none";

            } else {

              form.style.display = "flex";

            }
          });
        });
      }
    };

    // Función para setear el valor seleccionado: 
    const setSelectedStore = () => {
      const locationUserSettings = JSON.parse(localStorage.getItem('locationUserSettings'));
      const locationOption = document.getElementById('location-option');
      const locationAction = document.getElementById('location-action');

      if (locationUserSettings && locationOption && locationAction) {

        locationOption.textContent = '';
        locationAction.textContent = '';

        if (locationUserSettings.shippingType === "pickup") {
          locationOption.textContent = `${locationUserSettings.store}`;
          locationAction.textContent = `CAMBIAR`;
        } else {
          locationOption.textContent = `Envío a domicilio`;
          locationAction.textContent = `CAMBIAR`;
        }
      }
    }

    const filterStoresByCity = (selectCityValue, storeOptions) => {    
      storeOptions.forEach(option => {
        if (option.getAttribute('data-city') === selectCityValue) {
          option.classList.remove('hidden');
        } else {
          option.classList.add('hidden');
        }
      });
    }

    const handleCityChange = (selectLevel1, selectLevel2) => {
      selectLevel1.addEventListener('change', (event) => {
        filterStoresByCity(event.target.value, storeOptions);
        selectLevel2.disabled = false;
        selectLevel2.value = '';
      });
    };
  
    setSelectedStore();

    openModal(open);
    closeModal(close);
    saveInfo(action);
    setDeliveryOptions(options);
    handleCityChange(selectLevel1, selectLevel2);

    updateLocationParamInUrl(paramKey);

    function setModalConfiguration(modal, options) {

      if (modal) {

        if (localStorage.getItem('locationUserSettings') === null) { // Si no existe, lo configura en el local storage. 

          localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings));

          localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings));

        } else {

          if (JSON.parse(localStorage.getItem('locationUserSettings')).city !== null && JSON.parse(localStorage.getItem('locationUserSettings')).store !== null) {

            // Envio a Domicilio - Retiro en Tienda
            options.forEach((el) => {
              el.classList.remove("location__modal-type-option--active");
              if (el.dataset.locationOption === JSON.parse(localStorage.getItem('locationUserSettings')).shippingType) {
                el.classList.add("location__modal-type-option--active")
              }
            }
            );
          }

          if (JSON.parse(localStorage.getItem('locationUserSettings')).shippingType === 'pickup') {

            form.style.display = 'flex';

            if (JSON.parse(localStorage.getItem('locationUserSettings')).shippingType.city !== "" && JSON.parse(localStorage.getItem('locationUserSettings')).store !== "") {

              selectLevel1.value = JSON.parse(localStorage.getItem('locationUserSettings')).city.trim();

              filterStoresByCity(selectLevel1.value, storeOptions);
              
              if (selectLevel2.disabled === true) {
                selectLevel2.disabled = false;
                selectLevel2.value = JSON.parse(localStorage.getItem('locationUserSettings')).store.trim();
              } else {
                selectLevel2.value = JSON.parse(localStorage.getItem('locationUserSettings')).store.trim();
              }

            }

          } else {

            form.style.display = "none";

          }
        }

        modal.style.display = "flex";
      }

    }

    // Mostrar el modal después de un segundo de carga:
    if ((!localStorage.getItem('locationUserSettingsSaved') && !localStorage.getItem('locationUserSettingsClosed')) && !url.includes('/cart')) {      
      setTimeout(() => setModalConfiguration(modal, options), 1000);
    }

    // Si no existe la configuración, se crea la llave y el valor:
    if (localStorage.getItem('locationUserSettings') === null) {
      localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings))
    }

    // Función para remover mensajes de error
    function removeError() {
      const error = document.getElementById('location__error');
      if (error) error.remove();
    }

    // Función que revisa la URL 
    function updateLocationParamInUrl(globalParamKey) {

      // Verificar si la URL actual contiene '/collection'
      const currentPath = window.location.pathname;
      if (!currentPath.includes('/collections')) {
        return;
      }

      const locationUserSettings = JSON.parse(localStorage.getItem('locationUserSettings'));
      const url = new URL(window.location.href);
            
      if (!locationUserSettings || !locationUserSettings.paramKey || !locationUserSettings.paramValue) {        
        
        if (url.searchParams.has(globalParamKey)) {
          url.searchParams.delete(globalParamKey);
          window.history.replaceState({}, '', url.toString());
          location.reload();
        }
        return;
      }   

      const paramKey = locationUserSettings.paramKey; 
      const paramValue = locationUserSettings.paramValue;     
           
      // Si el parámetro existe y el valor es igual, no hacer nada
      if (url.searchParams.has(paramKey) && url.searchParams.get(paramKey) === paramValue) return;
      
      // Si no existe o el valor es diferente, lo actualiza
      url.searchParams.set(paramKey, paramValue);
      window.history.replaceState({}, '', url.toString());
      location.reload();

    }

  })();

});
